<template>
  <div>
    <main role="main">
      <div  class="container">   
        <section id="culture" class="fond">
          <h1 data-aos="fade-right" data-aos-delay="200">{{ $t("home.nav.culture") }}</h1>
          <div class="content" data-aos="fade-left" data-aos-delay="400">
            <div class="emploi">
              <div class="title" v-html="$t('culture.recruiting.title')">Nous recrutons !</div>
              <ul>
                <!--<li>
                  <b-link v-html="$t('culture.recruiting.offer1')" target="_blank" :href='$t("culture.recruiting.offer1.url")'>
                    Stage business developer avec bases d’allemand, en startup Sport Web - Mashup Web - Paris (75)
                  </b-link>
                </li>-->
                <li>
                  <b-link v-html="$t('culture.recruiting.offer2')" target="_blank" :href='$t("culture.recruiting.offer2.url")'>
                    Stage business developer avec bases d’allemand, en startup Sport Web - Mashup Web - Paris (75)
                  </b-link>
                </li>
                <li>
                  <b-link v-html="$t('culture.recruiting.offer3')" target="_blank" :href='$t("culture.recruiting.offer3.url")'>
                    Stage business developer avec bases d’allemand, en startup Sport Web - Mashup Web - Paris (75)
                  </b-link>
                </li>
              </ul>
            </div>
            
            <div class="presse">
              <div class="title" v-html="$t('culture.presse.title')">On parle de nous !</div>
              <ul>
                <li data-aos="fade-right" data-aos-delay="100">
                  <b-link target="_blank" :href='$t("culture.presse.news17.url")'>
                    <div class="date" v-html="$t('culture.presse.news17.date')">20 Décembre 2022</div>
                    <img class="logo-presse" alt="youtube.com" src="../../assets/presseaufutur.jpg">
                    <div class="editeur" v-html="$t('culture.presse.news17.title')">Interview de Matthieu GUDEFIN, Fondateur de MASHUP WEB SOCIAL, sur le plateau Broadcast-associés de la Presse au Futur 2022.</div>
                  </b-link>
                </li>
                <li data-aos="fade-right" data-aos-delay="100">
                  <b-link target="_blank" :href='$t("culture.presse.news16.url")'>
                    <div class="date" v-html="$t('culture.presse.news16.date')">12 Octobre 2021</div>
                    <img class="logo-presse" alt="actu.fr" src="../../assets/icon-audacieux-normands-red.svg">
                    <div class="editeur">Les audacieux Normands (Caisse d’Epargne)</div>
                    <div class="titre" v-html="$t('culture.presse.news16.title')">Matthieu Gudefin, un entrepreneur expérimenté</div>
                  </b-link>
                </li>
                <li data-aos="fade-right" data-aos-delay="100">
                  <b-link target="_blank" :href='$t("culture.presse.news15.url")'>
                    <div class="date" v-html="$t('culture.presse.news15.date')">2 Septembre 2020</div>
                    <img class="logo-presse" alt="actu.fr" src="../../assets/icon-informatiquenews.png">
                    <div class="editeur">InformatiqueNews.fr</div>
                    <div class="titre" v-html="$t('culture.presse.news15.title')">Mashup Web simplifie l’animation des réseaux sociaux</div>
                  </b-link>
                </li>

                <li data-aos="fade-right" data-aos-delay="100">
                  <b-link target="_blank" :href='$t("culture.presse.news1.url")'>
                    <div class="date" v-html="$t('culture.presse.news1.date')">18 Août 2019</div>
                    <img class="logo-presse" alt="actu.fr" src="../../assets/logo-presse-actu_200x200.jpg">
                    <div class="editeur">Actu.fr</div>
                    <div class="titre" v-html="$t('culture.presse.news1.title')">À Rouen, la start-up Mashup Web a fait ses preuves et va pouvoir vendre son savoir-faire</div>
                  </b-link>
                </li>
                <li data-aos="fade-right" data-aos-delay="100">
                  <b-link target="_blank" :href='$t("culture.presse.news2.url")'>
                    <div class="date" v-html="$t('culture.presse.news2.date')">5 août 2019</div>
                    <img class="logo-presse" alt="Rude Baguette" src="../../assets/logo-presse-rude-baguette_200x200.jpeg">
                    <div class="editeur">Rude Baguette</div>
                    <div class="titre" v-html="$t('culture.presse.news2.title')">Levée de fonds de 380 000 euros pour l’agrégateur de contenus Mashup Web</div>
                  </b-link>
                </li>
                <li data-aos="fade-right" data-aos-delay="100">
                  <b-link target="_blank" :href='$t("culture.presse.news3.url")'>
                    <div class="date" v-html="$t('culture.presse.news3.date')">30 juillet 2019</div>
                    <img class="logo-presse" alt="Logo Digital No Limit" src="../../assets/logo-presse-dnl_200x200.jpg">
                    <div class="editeur">Digital No Limit</div>
                    <div class="titre" v-html="$t('culture.presse.news3.title')">Jolie levée de fonds pour Mashup Web</div>
                  </b-link>
                </li>
                <li data-aos="fade-right" data-aos-delay="100">
                  <b-link target="_blank" :href='$t("culture.presse.news4.url")'>
                    <div class="date" v-html="$t('culture.presse.news4.date')">26 juillet 2019</div>
                    <img class="logo-presse" alt="Tendance Ouest" src="../../assets/logo-presse-tandance-ouest_200x200.jpg">
                    <div class="editeur">Tendance Ouest</div>
                    <div class="titre" v-html="$t('culture.presse.news4.title')">Rouen. Mashup web : la start-up rouennaise boucle une levée de fonds de 380 000 euros</div>
                  </b-link>
                </li>
                <li data-aos="fade-right" data-aos-delay="100">
                  <b-link target="_blank" :href='$t("culture.presse.news5.url")'>
                    <div class="date" v-html="$t('culture.presse.news5.date')">10 juillet 2019</div>
                    <img class="logo-presse" alt="Le Journal des Entreprises" src="../../assets/logo-presse-journal-des-entreprises_200x200.jpg">
                    <div class="editeur">Le Journal des Entreprises</div>
                    <div class="titre" v-html="$t('culture.presse.news5.title')">Mashup web lève près de 400 000 euros</div>
                  </b-link>
                </li>
                <li data-aos="fade-right" data-aos-delay="100">
                  <b-link target="_blank" :href='$t("culture.presse.news6.url")'>
                    <div class="date" v-html="$t('culture.presse.news6.date')">9 avril 2017</div>
                    <img class="logo-presse" alt="Alloweb" src="../../assets/logo-presse-alloweb_200x200.jpg">
                    <div class="editeur">Alloweb</div>
                    <div class="titre" v-html="$t('culture.presse.news6.title')">INTERVIEW</div>
                  </b-link>
                </li>
                <li data-aos="fade-right" data-aos-delay="100">
                  <b-link target="_blank" :href='$t("culture.presse.news7.url")'>
                    <div class="date" v-html="$t('culture.presse.news7.date')">15 mars 2017</div>
                    <img class="logo-presse" alt="IT Numeric" src="../../assets/logo-presse-it-numerique-200x200.jpg">
                    <div class="editeur">IT Numeric</div>
                    <div class="titre" v-html="$t('culture.presse.news7.title')">Après sa levée de fonds, Mashup Web se lance dans le B2B</div>
                  </b-link>
                </li>
                <li data-aos="fade-right" data-aos-delay="100">
                  <b-link target="_blank" :href='$t("culture.presse.news8.url")'>
                    <div class="date" v-html="$t('culture.presse.news8.date')">Février 2017</div>
                    <img class="logo-presse" alt="Le Journal des Entreprises" src="../../assets/logo-presse-journal-des-entreprises_200x200.jpg">
                    <div class="editeur">Le Journal des Entreprises</div>
                    <div class="titre" v-html="$t('culture.presse.news8.title')">La revue de presse pour les "fans"</div>
                  </b-link>
                </li>
                <li data-aos="fade-right" data-aos-delay="100">
                  <b-link target="_blank" :href='$t("culture.presse.news9.url")'>
                    <div class="date" v-html="$t('culture.presse.news9.date')">16 janvier 2017</div>
                    <img class="logo-presse" alt="Les Echos" src="../../assets/logo-presse-les-echos_200x200.jpg">
                    <div class="editeur">Les Echos</div>
                    <div class="titre" v-html="$t('culture.presse.news9.title')">Le Pitch</div>
                  </b-link>
                </li>
                <li data-aos="fade-right" data-aos-delay="100">
                  <b-link target="_blank" :href='$t("culture.presse.news10.url")'>
                    <div class="date" v-html="$t('culture.presse.news10.date')">16 janvier 2017</div>
                    <img class="logo-presse" alt="Ecran Mobile" src="../../assets/logo-presse-ecran-mobile_200x200.jpg">
                    <div class="editeur">Ecran Mobile</div>
                    <div class="titre" v-html="$t('culture.presse.news10.title')">Agrégation : MashupWeb lève 500 000 euros</div>
                  </b-link>
                </li>
                <li data-aos="fade-right" data-aos-delay="100">
                  <b-link target="_blank" :href='$t("culture.presse.news11.url")'>
                    <div class="date" v-html="$t('culture.presse.news11.date')">13 janvier 2017</div>
                    <img class="logo-presse" alt="Alliancy" src="../../assets/logo-presse-alliancy_200x200.jpg">
                    <div class="editeur">Alliancy</div>
                    <div class="titre" v-html="$t('culture.presse.news11.title')">L’agrégateur de contenus Mashup Web lève 500 000 euros</div>
                  </b-link>
                </li>
                <li data-aos="fade-right" data-aos-delay="100">
                  <b-link target="_blank" :href='$t("culture.presse.news12.url")'>
                    <div class="date" v-html="$t('culture.presse.news12.date')">13 juin 2016</div>
                    <img class="logo-presse" alt="Paris Normandie" src="../../assets/logo-presse-paris-normandie_200x200.png">
                    <div class="editeur">Paris Normandie</div>
                    <div class="titre" v-html="$t('culture.presse.news12.title')">Une application pensée par un Rouennais qui permet de suivre l’actualité de votre club partout, tout le temps</div>
                  </b-link>
                </li>
                <li data-aos="fade-right" data-aos-delay="100">
                  <b-link target="_blank" :href='$t("culture.presse.news13.url")'>
                    <div class="date" v-html="$t('culture.presse.news13.date')">21 décembre 2015</div>
                    <img class="logo-presse" alt="Journal Du Net" src="../../assets/logo-presse-jdn_200x200.png">
                    <div class="editeur">Journal Du Net</div>
                    <div class="titre" v-html="$t('culture.presse.news13.title')">L'appli de la semaine : Football Addict pour tout savoir sur vos équipes favorites</div>
                  </b-link>
                </li>
                <li data-aos="fade-right" data-aos-delay="100">
                  <b-link target="_blank" :href='$t("culture.presse.news14.url")'>
                    <div class="date" v-html="$t('culture.presse.news14.date')">16 octobre 2015</div>
                    <img class="logo-presse" alt="Satellinet (Mind)" src="../../assets/logo-presse-mind_200x200.jpg">
                    <div class="editeur">Satellinet (Mind)</div>
                    <div class="titre" v-html="$t('culture.presse.news14.title')">Mashup Web : nouveau projet d'agrégation de contenus</div>
                  </b-link>
                </li>
              </ul>
            </div>
          </div>
        </section>    
      </div>
    </main>
  </div>
</template>

<script>


export default {
  name: 'CulturePage',
}
</script>

<style scoped>
  .emploi .title {
    font-size: 30px;
    margin-bottom: 20px;
  }
  .emploi li {
    list-style: inside;
  }

  .presse {
    margin-top: 50px;
  }
  .presse .title {
    font-size: 30px;
    text-align: center;
    margin-bottom: 20px;
  }
  .presse ul {
    margin-left: 160px;
    padding-left: 20px;
    border-left: 2px solid #25569f;
  }
  .presse li {
    position: relative;
    margin-bottom: 80px;
    line-height: 1.5;
  }
  .presse li:before {
    content: ' ';
    width: 10px;
    height: 10px;
    border-radius: 50%;
    background: #25569f;
    position: absolute;
    left: -26px;
    top: 8px;
  }
  .presse li .date {
    position: absolute;
    left: -200px;
    text-align: right;
    width: 170px;
    font-weight: 600;
  }
  .presse li img.logo-presse {
    width: 70px;
    position: absolute;
    left: -110px;
    top: 30px;
  }
  .presse li .editeur {
    font-weight: 500;
  }
</style>